import React, { ReactNode } from 'react'
import { RichText, RichTextBlock } from 'prismic-reactjs'
import {
  Description,
  HeroCenter,
  HeroGrid,
  HeroIntro,
  Illustration,
  TextBlock,
  Title,
} from './style'
import { HeroEyebrow, HeroTitle } from '../../hero/style'
import ValueProposition from '../../../elements/value_proposition'

type ColumnGrid = {
  children: ReactNode
  eyebrow: string | null
  illustration: any
  textBlock: any
  title: RichTextBlock[]
  valuePropositions: any
}

const ThreeColumnGrid = ({
  children,
  eyebrow,
  illustration,
  textBlock,
  title,
  valuePropositions,
}: ColumnGrid) => {
  return (
    <>
      <HeroIntro>
        <HeroEyebrow>{eyebrow}</HeroEyebrow>
        <HeroTitle>{RichText.render(title)}</HeroTitle>
      </HeroIntro>
      <HeroGrid>
        <TextBlock className={'block-1'}>
          <Title>{RichText.render(textBlock.items[0].text_block_title.raw)}</Title>
          <Description>
            {RichText.render(textBlock.items[0].text_block_description.raw)}{' '}
          </Description>
          <ValueProposition text={valuePropositions.items[0].text} alignment="align-right" />
        </TextBlock>
        <HeroCenter>
          {children}
          <Illustration>{illustration}</Illustration>
          {valuePropositions.items[1].text !== null && (
            <ValueProposition text={valuePropositions.items[1].text} alignment="align-center" />
          )}
        </HeroCenter>
        <TextBlock className={'block-2'}>
          <Title>{RichText.render(textBlock.items[1].text_block_title.raw)}</Title>
          <Description>
            {RichText.render(textBlock.items[1].text_block_description.raw)}{' '}
          </Description>
          <ValueProposition text={valuePropositions.items[2].text} alignment="align-left" />
        </TextBlock>
      </HeroGrid>
    </>
  )
}

export default ThreeColumnGrid
